import React, { useState } from "react";
import _ from "lodash";

import { FiShare, FiFileText } from "react-icons/fi";

import ClickToCopyWrapper from "components/common/ClickToCopyWrapper";
import UprTargetingPopover from "components/ops-mgmt/account/custom-upr/UprTargetingPopover";
import UprSegmentInfoPopover from "./UprSegmentInfoPopover";
import UprCustomInfoPopover from "./UprCustomInfoPopover";
import HighLightRowWrapper from "components/common/HighLightRowWrapper";
import SimpleTooltip from "components/common/SimpleTooltip";

import UprPriceSection from "./UprPriceSection";
import PriceSettingView from "components/common/PriceSettingView";
import PriceSectionView from "components/common/PriceSectionView";
import UprName from "components/common/UprName";

function GamUprTable({
  items,
  units,
  placement,
  virtualPlacements,
  networkId,
  networkInfo,
  segmentData,
  customData,
  currency,
  demandSource,
  isI2wRuleSelected,
  selectedItems,
  relevantLogs,
  handleSelect,
  handleCheckLog,
}) {
  const [popupId, setPopupId] = useState("");
  const networkCode = networkInfo.code;

  function handleSelectItem(itemId) {
    if (itemId === "ALL") {
      if (selectedItems.length === items.length) {
        handleSelect([]);
      } else {
        handleSelect(items.map((item) => item.externalId));
      }
    } else {
      const tempList = [...selectedItems];
      const index = tempList.indexOf(itemId);
      if (index !== -1) {
        tempList.splice(index, 1);
      } else {
        tempList.push(itemId);
      }
      handleSelect(tempList);
    }
  }

  const parsedItems = _.map(items, (d) => ({
    ...d,
    segment:
      d.props && d.props.type === "UPR_SEGMENTATION"
        ? _.find(segmentData, {
            id: d.props.segmentId,
          })
        : null,
    custom:
      d.props && d.props.type === "CUSTOM"
        ? _.find(customData, {
            id: d.props.id,
          })
        : null,
  }));

  return (
    <table className="table w-full text-sm">
      <thead className="border-b bg-gray-200 text-xs text-blue-800">
        <tr>
          <th className="px-2 text-center">
            <input
              style={{
                width: "18px",
                height: "18px",
                marginTop: "4px",
              }}
              type="checkbox"
              checked={
                items.length > 0 && selectedItems.length === items.length
              }
              onChange={() => handleSelectItem("ALL")}
            ></input>
          </th>
          <th className="border px-2 py-1 text-center ">External ID</th>
          <th className="border px-2 py-1 text-left ">Name</th>
          <th className="border px-2 py-1 text-center ">Logs</th>
          <th className="border px-2 py-1 text-center ">Status</th>
          <th className="border px-2 py-1 text-right ">Price Section</th>
          <th className="border px-2 py-1 text-left">Targeting Section</th>
          {/* {isI2wRuleSelected && ( */}
          <th className="border px-2 py-1 text-right">Type</th>
          {/* )} */}
          {isI2wRuleSelected && (
            <th className="border px-2 py-1 text-right">Props Section</th>
          )}
          <th className="border px-2 py-1 text-center">Actions</th>
        </tr>
      </thead>
      <tbody className="bg-white  text-gray-900">
        {parsedItems.map((item, i) => {
          const gamLink = `https://admanager.google.com/${networkCode}#inventory/pricing/detail/pricing_id=${item.externalId}&tab=settings`;

          function propsElement(item) {
            let element = "";
            if (!item.props) {
              return "-";
            }

            switch (item.props.type) {
              case "KEY16": {
                element = (
                  <div>
                    <div>UPR ID: {item.props.uprId}</div>
                    <PriceSectionView
                      item={{
                        price: item.props.price,
                        priceType: item.props.priceType,
                      }}
                      currency={item.priceSection.currency}
                    ></PriceSectionView>
                  </div>
                );
                break;
              }
              case "KEY16L1": {
                element = (
                  <div>
                    <PriceSectionView
                      item={{
                        price: item.props.price,
                        priceType: item.props.priceType,
                      }}
                      currency={item.priceSection.currency}
                    ></PriceSectionView>
                  </div>
                );
                break;
              }

              case "CUSTOM": {
                const priceSettings = _.get(item, [
                  "props",
                  "priceSection",
                  "priceSettings",
                ]);
                element = (
                  <div>
                    <UprCustomInfoPopover
                      networkId={networkId}
                      networkInfo={networkInfo}
                      custom={item.custom}
                      units={units}
                      placement={placement}
                      virtualPlacements={virtualPlacements}
                      triggerElement={
                        <div className="inline-block cursor-pointer  text-blue-600 hover:text-blue-700 hover:underline">
                          ID: {item.props.id}
                        </div>
                      }
                      place="left top"
                      onOpen={() => setPopupId(item.externalId)}
                      onClose={() => setPopupId("")}
                    ></UprCustomInfoPopover>

                    <div className="font-semibold">
                      Price Settings ({priceSettings.length}):
                    </div>
                    <div className="flex-row gap-2 bg-gray-200">
                      {priceSettings &&
                        priceSettings.map((s, i) => {
                          return (
                            <PriceSettingView s={s} key={i}></PriceSettingView>
                          );
                        })}
                    </div>
                  </div>
                );
                break;
              }

              case "UPR_SEGMENTATION": {
                const priceSettings = _.get(item, ["props", "priceSettings"]);
                element = (
                  <div>
                    <UprSegmentInfoPopover
                      networkId={networkId}
                      segment={item.segment}
                      triggerElement={
                        <div className="inline-block cursor-pointer  text-blue-600 hover:text-blue-700 hover:underline">
                          Segment ID: {item.props.segmentId}
                        </div>
                      }
                      place="left top"
                      onOpen={() => setPopupId(item.externalId)}
                      onClose={() => setPopupId("")}
                    ></UprSegmentInfoPopover>
                    <div>Price Setting ID: {item.props.priceSettingId}</div>
                    <div>Price Index: {item.props.priceIndex}</div>
                    <div>
                      OPT Type:{" "}
                      <span className="rounded bg-teal-100 px-1 font-semibold text-teal-900">
                        {item.props.optType}
                      </span>
                    </div>

                    <div className="border-t">
                      <div className="font-semibold">
                        Price Settings ({priceSettings.length}):
                      </div>
                      <div className="flex-row gap-2 bg-gray-200">
                        {priceSettings &&
                          priceSettings.map((s, i) => {
                            return (
                              <PriceSettingView
                                s={s}
                                key={i}
                              ></PriceSettingView>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                );
                break;
              }

              case "PREBID": {
                const priceSettings = _.get(item, ["props", "priceSettings"]);
                element = (
                  <div>
                    <div className="font-semibold">
                      Price Settings ({priceSettings.length}):
                    </div>
                    <div className="flex-row gap-2 bg-gray-200">
                      {priceSettings &&
                        priceSettings.map((s, i) => {
                          return (
                            <PriceSettingView s={s} key={i}></PriceSettingView>
                          );
                        })}
                    </div>
                  </div>
                );
                break;
              }

              default: {
                //
              }
            }

            return element;
          }

          return (
            <HighLightRowWrapper
              selected={popupId === item.externalId}
              key={`${item.externalId}-${i}`}
            >
              <td className="px-2 text-center">
                <input
                  style={{
                    width: "18px",
                    height: "18px",
                    marginTop: "4px",
                  }}
                  type="checkbox"
                  checked={selectedItems.indexOf(item.externalId) !== -1}
                  onChange={() => handleSelectItem(item.externalId)}
                ></input>
              </td>
              <td className="border px-2 py-1 text-right">
                <div className="flex items-center justify-between">
                  <span
                    className={`font-mono ${
                      popupId === item.externalId ? "font-semibold" : ""
                    }`}
                  >
                    {item.externalId}
                  </span>

                  <div className="flex items-center text-blue-500">
                    <ClickToCopyWrapper
                      copyText={gamLink}
                      tooltipMessage="Click to copy GAM link"
                    ></ClickToCopyWrapper>
                  </div>
                </div>
              </td>
              <td className="border px-2 py-1 text-left">
                <UprName item={item}></UprName>
              </td>
              <td className="border px-2 py-1 text-center">
                {_.some(relevantLogs, ["entityId", item.externalId]) && (
                  <SimpleTooltip tooltipText="View Change Log">
                    <button
                      type="button"
                      className="flex items-center px-2 text-blue-600 hover:text-blue-700"
                      onClick={() => {
                        handleCheckLog(item.externalId);
                      }}
                    >
                      <FiFileText></FiFileText>
                    </button>
                  </SimpleTooltip>
                )}
              </td>
              <td className="border px-2 py-1 text-center">{item.status}</td>
              <td className="border px-2 py-1 text-right">
                <UprPriceSection
                  demandSource={demandSource}
                  item={item.priceSection}
                  currency={item.priceSection.currency}
                  networkId={networkId}
                  onOpen={() => setPopupId(item.externalId)}
                  onClose={() => setPopupId("")}
                ></UprPriceSection>
              </td>
              <td className="border px-2 py-1 text-left font-mono">
                <div>
                  {item.targetingSection && (
                    <UprTargetingPopover
                      id={item.externalId}
                      name={item.uprName}
                      networkId={networkId}
                      units={units}
                      virtualPlacements={virtualPlacements}
                      targetingSection={item.targetingSection}
                      triggerElement={
                        <div className="inline-block cursor-pointer  text-blue-600 hover:text-blue-700 hover:underline">
                          {Object.keys(item.targetingSection).join(", ")}
                        </div>
                      }
                      onOpen={() => setPopupId(item.externalId)}
                      onClose={() => setPopupId("")}
                    ></UprTargetingPopover>
                  )}
                </div>
              </td>
              {/* {isI2wRuleSelected && ( */}
              <td className="border px-2 py-1 text-right">
                {item.props ? item.props.type : "-"}
              </td>
              {/* )} */}
              {isI2wRuleSelected && (
                <td className="border px-2 py-1 text-right">
                  {propsElement(item)}
                </td>
              )}
              <td className="border px-2 py-1 text-center text-base font-semibold text-blue-500">
                <SimpleTooltip tooltipText="Import to Custom UPR">
                  <button
                    type="button"
                    className="flex items-center px-2 hover:text-blue-700"
                    onClick={() => {
                      window.open(
                        `${window.location.origin}/#/ops-mgmt/account/network/${networkId}/upr-setting?importId=${item.externalId}`
                      );
                    }}
                  >
                    <FiShare></FiShare>
                  </button>
                </SimpleTooltip>
              </td>
            </HighLightRowWrapper>
          );
        })}
      </tbody>
    </table>
  );
}

export default GamUprTable;
